
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30783',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30783",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55310",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8332",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11791",
  "I18n": "static-7.1673",
  "quartz": "static-1.7456",
  "quartz-config": "static-1.1234",
  "quartz-core": "static-1.6675",
  "react-dlb": "static-1.88",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.80",
  "reselect": "static-3.12",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.920",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55297",
  "feedback-utils": "static-1.55301",
  "forms-embed-utils-lib": "static-1.4765",
  "forms-utils-lib": "static-1.13092",
  "foundations-assets": "static-1.5186",
  "foundations-components": "static-1-ech-accordiontransition-jank.36",
  "foundations-theming": "static-1.4777",
  "hub-http": "static-1.6513",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12098",
  "icons": "static-2.683",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4130",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17022",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5557",
  "react-virtualized": "static-2.107",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.502",
  "tinymce-plugins": "static-1.58216",
  "transmute": "static-2.97",
  "ui-images": "static-2.1249",
  "UIComponents": "static-3.8737",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3621",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3733",
  "quartz-webpack": "static-1.3680",
  "foundations-theming-specialty": "static-1.2493",
  "property-description-translator": "static-1.4139",
  "HeadJS": "static-2.797",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3443",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4614",
  "jasmine-runner": "static-1.6752",
  "opentelemetry-fe-types": "static-1.72",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.879",
  "hubspotter-http": "static-1.4864",
  "mobile-manifest-mixins": "static-1.576",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.447",
  "quartz-auth": "static-1.1131",
  "quartz-head": "static-1.1121",
  "quartz-i18n": "static-1.1131",
  "quartz-routing": "static-1.886",
  "quartz-test": "static-1.1131",
  "quartz-tracking": "static-1.835",
  "trellis-components": "static-1.2660",
  "ui-fonts": "static-1.1053",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.193",
  "conversations-skeleton-state": "static-1.7547",
  "reference-resolvers": "static-1.8482",
  "sanitize-text": "static-1.8455",
  "PatternValidationJS": "static-1.3194",
  "ReduxMessenger": "static-2.10671",
  "outpost": "static-1.4456",
  "rpc-client-utils": "static-1.4968",
  "sanitize": "static-1.4773",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.36",
  "floating-ui": "static-1.63",
  "hs-story-utils": "static-1.9726",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.70",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2641",
  "bend-plugin-foundations-theming": "static-1.3260",
  "foundations-theming-base": "static-1.3762",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.295",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "ai-components-ui-library": "static-1.9712",
  "atom": "static-1.5388",
  "codemirror": "static-5.102",
  "content-assistance-lib": "static-1.8198",
  "ContentUtils": "static-1.69122",
  "data-token-picker": "static-1.16888",
  "file-manager-components": "static-1.24496",
  "FileManagerCore": "static-1.39995",
  "FileManagerLib": "static-1.40136",
  "frontend-preferences-client": "static-1.8224",
  "hub-http-contrib": "static-1.3340",
  "interframe": "static-3.5056",
  "layout-dnd-components": "static-1.12966",
  "layout-dnd-utils": "static-1.11941",
  "property-translator": "static-1.5696",
  "react-codemirror": "static-1.10941",
  "react-colorpicker": "static-2.10519",
  "reference-resolvers-lite": "static-1.8404",
  "rich-text-lib": "static-1.20304",
  "tinymce-data": "static-1.41187",
  "tinymce-themes": "static-1.57072",
  "ui-addon-emoji-picker": "static-1.10187",
  "ui-addon-sales-email": "static-1.5513",
  "ui-brand-identity-lib": "static-1.16471",
  "bender-build-tools": "static-1.3444",
  "opentelemetry-web": "static-1.13",
  "hub-http-shared-msw-handlers": "static-1.10616",
  "hubspotter-http-shared-msw-handlers": "static-1.10614",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "trellis-theming": "static-1.1275",
  "tanstack-virtual": "static-1.38",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.378",
  "chirp-fetch": "static-1.2195",
  "stylex-utils": "static-1.140",
  "chatspot-core": "static-1.23024",
  "copilot-toolkit": "static-1.11847",
  "customer-data-objects-ui-components": "static-1.13331",
  "data-fetching-client": "static-1.9956",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5059",
  "ui-addon-video-player": "static-1.9004",
  "ui-coaching-tips": "static-1.29301",
  "usage-tracker": "static-1.7637",
  "cms-field-types": "static-1.5115",
  "content-icons-ui": "static-1.2364",
  "integrations-lib": "static-1.17025",
  "customer-data-objects": "static-1.7993",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1731",
  "apollo-link-hub-http": "static-2.4957",
  "apollo-stack-hubspot": "static-3.94",
  "graphql": "static-1.89",
  "immer": "static-1.101",
  "immerable": "static-1.4449",
  "ui-addon-iframeable": "static-1.9377",
  "video-components-external": "static-1.12144",
  "video-data-lib": "static-1.35802",
  "breeze-artifacts-sdk": "static-1.332",
  "audio-components": "static-1.6343",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29810",
  "FileManagerImages": "static-1.37647",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.36",
  "html-to-image": "static-1.61",
  "redux-toolkit": "static-1.78",
  "salesImages": "static-1.563",
  "ui-universal-auth": "static-1.9406",
  "urlinator": "static-1.4834",
  "video-components": "static-1.14146",
  "video-embed": "static-1.36636",
  "ts-schema": "static-1.4294",
  "ContentData": "static-1.69197",
  "layout-data-lib": "static-1.10266",
  "react-dnd-compat": "static-1.4918",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1845",
  "external-options-client-types": "static-1.4339",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7194",
  "hs-promise-utils": "static-1.5896",
  "inbound-db-properties-service-client": "static-1.4054",
  "NamespacedHubStyle": "static-2.9265",
  "growth-onboarding-confetti": "static-1.3362",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11448",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5754",
  "magpie-types": "static-1.5214",
  "simple-logging-lib": "static-1.3352",
  "avatar-components": "static-1.2782",
  "customer-data-ui-utilities": "static-1.10130",
  "growth-onboarding-feedback-components": "static-1.6885",
  "flux-actions": "static-1.368",
  "hubspot-apollo-client": "static-1.5178",
  "integrations-error-boundary-lib": "static-1.14440",
  "integrations-tracking-lib": "static-1.5908",
  "laboratory-lib": "static-3.7453",
  "native-integrations-shared-strings": "static-1.8078",
  "redux-observable": "static-1.75",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10571",
  "unified-auth": "static-1.920",
  "breeze-engine-chat-components": "static-1.709",
  "breeze-engine-core": "static-1.1009",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "navigation-messaging": "static-1.8154",
  "content-media-composition-data-lib": "static-1.13236",
  "content-media-compositions": "static-2.17243",
  "idb-keyval": "static-1.51",
  "media-bridge-lib": "static-1.19405",
  "unified-auth-core-lib": "static-1.1202",
  "social-insights-client-types": "static-1.22706",
  "advanced-menus-core": "static-1.15575",
  "advanced-menus-lib": "static-1.12450",
  "ExportDialog": "static-6.10679",
  "ui-memberships-settings-lib": "static-1.34837",
  "conditional-properties-service-client": "static-1.4015",
  "crm-pipelines-api-client-types": "static-1.4348",
  "fdsr-migration-layer": "static-1.313",
  "framework-builder-read-service-client": "static-1.4220",
  "framework-data-schema-quick-fetch": "static-1.7099",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3910",
  "persist-promise": "static-1.4002",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.36",
  "reactive-lib": "static-1.1019",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.637",
  "universal-page-editor-lib": "static-1.3309",
  "adobe-sign-auth-lib": "static-1.453",
  "ads-unified-auth-lib": "static-1.1365",
  "generic-oauth-auth-lib": "static-1.48",
  "google-sheets-integration-lib": "static-1.1024",
  "microsoft-drive-auth-lib": "static-1.136",
  "surveymonkey-integration-lib": "static-1.481",
  "slack-ui-library": "static-1.10700",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4051",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15574",
  "simple-menus-lib": "static-1.17091",
  "crm-record-cards-service-types": "static-1.3787",
  "location-customization-utils-lib": "static-1.10090",
  "react-flip-move": "static-1.78"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30783",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55310",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8332",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11791",
  "I18n": "/I18n/static-7.1673",
  "quartz": "/quartz/static-1.7456",
  "quartz-config": "/quartz-config/static-1.1234",
  "quartz-core": "/quartz-core/static-1.6675",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reselect": "/reselect/static-3.12",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.920",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55297",
  "feedback-utils": "/feedback-utils/static-1.55301",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4765",
  "forms-utils-lib": "/forms-utils-lib/static-1.13092",
  "foundations-assets": "/foundations-assets/static-1.5186",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.36",
  "foundations-theming": "/foundations-theming/static-1.4777",
  "hub-http": "/hub-http/static-1.6513",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12098",
  "icons": "/icons/static-2.683",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4130",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17022",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5557",
  "react-virtualized": "/react-virtualized/static-2.107",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "tinymce-plugins": "/tinymce-plugins/static-1.58216",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1249",
  "UIComponents": "/UIComponents/static-3.8737",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3621",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3733",
  "quartz-webpack": "/quartz-webpack/static-1.3680",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2493",
  "property-description-translator": "/property-description-translator/static-1.4139",
  "HeadJS": "/HeadJS/static-2.797",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3443",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4614",
  "jasmine-runner": "/jasmine-runner/static-1.6752",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.72",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.879",
  "hubspotter-http": "/hubspotter-http/static-1.4864",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.576",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.447",
  "quartz-auth": "/quartz-auth/static-1.1131",
  "quartz-head": "/quartz-head/static-1.1121",
  "quartz-i18n": "/quartz-i18n/static-1.1131",
  "quartz-routing": "/quartz-routing/static-1.886",
  "quartz-test": "/quartz-test/static-1.1131",
  "quartz-tracking": "/quartz-tracking/static-1.835",
  "trellis-components": "/trellis-components/static-1.2660",
  "ui-fonts": "/ui-fonts/static-1.1053",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.193",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7547",
  "reference-resolvers": "/reference-resolvers/static-1.8482",
  "sanitize-text": "/sanitize-text/static-1.8455",
  "PatternValidationJS": "/PatternValidationJS/static-1.3194",
  "ReduxMessenger": "/ReduxMessenger/static-2.10671",
  "outpost": "/outpost/static-1.4456",
  "rpc-client-utils": "/rpc-client-utils/static-1.4968",
  "sanitize": "/sanitize/static-1.4773",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.36",
  "floating-ui": "/floating-ui/static-1.63",
  "hs-story-utils": "/hs-story-utils/static-1.9726",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2641",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3260",
  "foundations-theming-base": "/foundations-theming-base/static-1.3762",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.295",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9712",
  "atom": "/atom/static-1.5388",
  "codemirror": "/codemirror/static-5.102",
  "content-assistance-lib": "/content-assistance-lib/static-1.8198",
  "ContentUtils": "/ContentUtils/static-1.69122",
  "data-token-picker": "/data-token-picker/static-1.16888",
  "file-manager-components": "/file-manager-components/static-1.24496",
  "FileManagerCore": "/FileManagerCore/static-1.39995",
  "FileManagerLib": "/FileManagerLib/static-1.40136",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8224",
  "hub-http-contrib": "/hub-http-contrib/static-1.3340",
  "interframe": "/interframe/static-3.5056",
  "layout-dnd-components": "/layout-dnd-components/static-1.12966",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11941",
  "property-translator": "/property-translator/static-1.5696",
  "react-codemirror": "/react-codemirror/static-1.10941",
  "react-colorpicker": "/react-colorpicker/static-2.10519",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8404",
  "rich-text-lib": "/rich-text-lib/static-1.20304",
  "tinymce-data": "/tinymce-data/static-1.41187",
  "tinymce-themes": "/tinymce-themes/static-1.57072",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10187",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5513",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16471",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10616",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10614",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "trellis-theming": "/trellis-theming/static-1.1275",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.378",
  "chirp-fetch": "/chirp-fetch/static-1.2195",
  "stylex-utils": "/stylex-utils/static-1.140",
  "chatspot-core": "/chatspot-core/static-1.23024",
  "copilot-toolkit": "/copilot-toolkit/static-1.11847",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13331",
  "data-fetching-client": "/data-fetching-client/static-1.9956",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5059",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9004",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29301",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "cms-field-types": "/cms-field-types/static-1.5115",
  "content-icons-ui": "/content-icons-ui/static-1.2364",
  "integrations-lib": "/integrations-lib/static-1.17025",
  "customer-data-objects": "/customer-data-objects/static-1.7993",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1731",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4957",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "graphql": "/graphql/static-1.89",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4449",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9377",
  "video-components-external": "/video-components-external/static-1.12144",
  "video-data-lib": "/video-data-lib/static-1.35802",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.332",
  "audio-components": "/audio-components/static-1.6343",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29810",
  "FileManagerImages": "/FileManagerImages/static-1.37647",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.36",
  "html-to-image": "/html-to-image/static-1.61",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "salesImages": "/salesImages/static-1.563",
  "ui-universal-auth": "/ui-universal-auth/static-1.9406",
  "urlinator": "/urlinator/static-1.4834",
  "video-components": "/video-components/static-1.14146",
  "video-embed": "/video-embed/static-1.36636",
  "ts-schema": "/ts-schema/static-1.4294",
  "ContentData": "/ContentData/static-1.69197",
  "layout-data-lib": "/layout-data-lib/static-1.10266",
  "react-dnd-compat": "/react-dnd-compat/static-1.4918",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1845",
  "external-options-client-types": "/external-options-client-types/static-1.4339",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7194",
  "hs-promise-utils": "/hs-promise-utils/static-1.5896",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4054",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9265",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3362",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11448",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5754",
  "magpie-types": "/magpie-types/static-1.5214",
  "simple-logging-lib": "/simple-logging-lib/static-1.3352",
  "avatar-components": "/avatar-components/static-1.2782",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10130",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6885",
  "flux-actions": "/flux-actions/static-1.368",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5178",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14440",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5908",
  "laboratory-lib": "/laboratory-lib/static-3.7453",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8078",
  "redux-observable": "/redux-observable/static-1.75",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10571",
  "unified-auth": "/unified-auth/static-1.920",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.709",
  "breeze-engine-core": "/breeze-engine-core/static-1.1009",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "navigation-messaging": "/navigation-messaging/static-1.8154",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13236",
  "content-media-compositions": "/content-media-compositions/static-2.17243",
  "idb-keyval": "/idb-keyval/static-1.51",
  "media-bridge-lib": "/media-bridge-lib/static-1.19405",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1202",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "advanced-menus-core": "/advanced-menus-core/static-1.15575",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12450",
  "ExportDialog": "/ExportDialog/static-6.10679",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34837",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4015",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4348",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.313",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4220",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7099",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3910",
  "persist-promise": "/persist-promise/static-1.4002",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.36",
  "reactive-lib": "/reactive-lib/static-1.1019",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.637",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3309",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.453",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1365",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.48",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1024",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.136",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.481",
  "slack-ui-library": "/slack-ui-library/static-1.10700",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4051",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15574",
  "simple-menus-lib": "/simple-menus-lib/static-1.17091",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3787",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10090",
  "react-flip-move": "/react-flip-move/static-1.78"
}
};
